export default __webpack_public_path__ + "static/media/A4Select.2cd52092.svg";